import { Mui } from "@osu/react-ui";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { STATUSES } from "../../util/constants";
import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { selectAuthStatus, selectIsAdmin, selectName } from "../../services/authorization/slices";
import { ROUTE_KEYS, ROUTES } from "../../_configuration/routing/constants";
import { mergeSxStyles } from "../../util/functions";

const loginRoute = ROUTES[ROUTE_KEYS.LOGIN].path
const logoutRoute = ROUTES[ROUTE_KEYS.LOGOUT].path

function SignOut({ onClick, ...props }) {
  const isAdmin = useSelector(selectIsAdmin);
  const name = useSelector((state) => {
    return selectName(state);
  });

  return (
    <Mui.Box
      {...props}
      sx={mergeSxStyles(props.sx || {}, {
        display: "flex",
        alignItems: "center",
      })}
    >
      {name && (
        <Fragment>
          <Mui.Typography
            variant="body2"
            component="div"
            sx={[
              {
                display: "flex",
                flexDirection: "column",
              },
            ]}
          >
            {isAdmin && (
              <Mui.Typography
                variant="overline"
                sx={{
                  lineHeight: "normal",
                }}
              >
                Admin
              </Mui.Typography>
            )}
            {name}
          </Mui.Typography>
          <Mui.Divider
            sx={{
              marginLeft: 1,
            }}
            orientation="vertical"
            flexItem
          />
        </Fragment>
      )}
      <Mui.Button
        onClick={onClick}
        variant="text"
        color="secondary"
        component={RouterLink}
        to="/logout"
      >
        Sign Out
      </Mui.Button>
    </Mui.Box>
  );
}


function AuthButton(props = {}) {
  const status = useSelector(selectAuthStatus)
  const [inOrOut, setInOrOut] = useState("In")
  const { pathname } = useLocation()
  const onAuthPage = pathname.startsWith(loginRoute) || pathname.startsWith(logoutRoute)

  if(onAuthPage) {
    return false
  }

  if ([STATUSES.CLEARING, STATUSES.LOADING].includes(status)) {
    let label =  `Signing `
    if (inOrOut === "Out" || STATUSES.CLEARING === status) {
      label += ' Out'
    } else {
      label += ' In'
    }
    return (
        <Mui.Box {...props} sx={{display: "flex", flexDirection: "row"}}>
          <Mui.CircularProgress className="margin-right-1"/>
          <Mui.Typography variant="body1" className="margin-top-1">
            {label}
          </Mui.Typography>
        </Mui.Box>
    );
  }

  if (status === STATUSES.SUCCESS) {
    return (
      <SignOut {...props} onClick={() => setInOrOut("Out")} />
    );
  }
  let toPath = loginRoute
  if(!onAuthPage && toPath?.length > 1) {
    toPath = `${loginRoute}?from=${encodeURIComponent(pathname)}`
  }

  return (
    <Mui.Button onClick={() => setInOrOut("In")} variant="outlined" component={RouterLink} to={toPath} state={{
        redirectPath: pathname
      }} {...props}>
      Sign In
    </Mui.Button>
  );
}

export default AuthButton;